module.exports = __webpack_public_path__ + "static/media/Community_Care_C2.08e20197.pdf";


//////////////////
// WEBPACK FOOTER
// ./public/assets/pdfs/Community_Care_C2.pdf
// module id = 1325
// module chunks = 0